import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { Statescontex } from "../../context";

function Login({ setusername, setPassword, setG, setName, setconfirmpass }) {
    const { setErrorshow, setErrorMessage } = Statescontex();

    const onSuccess = (res) => {
        const user = jwtDecode(res.credential)
        console.log("LOGIN SUCCESS! Current user:", user.sub, user.email);
        setusername(user.email)
        setPassword(user.sub)
        setName(user.name)
        setconfirmpass(user.sub)
        setG(true)
    };

    const onFailure = (res) => {
        setErrorMessage("h_Login Failed, did you signup before?")
        setErrorshow(true)
        console.log("LOGIN FAILED! res:", res);
    };

    return (
        <div id="signInButton" className='flex justify-center'>
            <GoogleLogin
                onSuccess={onSuccess}
                onFailure={onFailure}
                theme='filled_black'
                shape="pill"
                size='large'
            />
        </div>
    );
}

export default Login;
